<template>
  <div class="company-warning company-warning--billing">
    <div class="company-warning__description description">
      Срок действия тарифа истек. Сайт временно недоступен. Продлите тариф, чтобы восстановить
      работу.
    </div>
    <a
      class="company-warning__btn"
      target="_blank"
      href="https://billing.motmom.com"
    >
      Продлить
    </a>
  </div>
</template>

<style scoped lang="scss">
@use '@/styles/company-warning';
</style>
